<template>
  <div class="" :class="{'mdc-layout-grid mdc-layout-grid__inner': cols !== 3}">
  	<!-- <div v-for="(item, index) in items" class="mdc-layout-grid__cell" v-show="((selected === -1 || selected === '') || item[ID] === selected) && index <= optionsToShow" :class="{'mdc-layout-grid__cell--span-12': item[ID] === selected || cols === 1, 'cell-6-xs': cols === 2 && item[ID] !== selected}">
  		<div class="btn btn--bordered" :class="{'btn--option': item[ID] === selected}" @click="set(item[ID])">
              <span v-if="item.length > 2 && item[ID] === selected">{{item[CUSTOM_TEXT]}}</span>
              <span v-else>{{item[TEXT]}}</span>
  			<span class="btn--edit" v-if="item[ID] === selected">edit</span> -->
  	<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="title !== ''">
  		<h3>{{title}}</h3>
  	</div>
  	<div v-for="(item, index) in items" v-show="index <= optionsToShow" class="" :class="{'mdc-layout-grid__cell mdc-layout-grid__cell--span-12': cols === 1, 'mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone': cols === 2, 'mdc-layout-grid__cell--3-columns': cols === 3, 'mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone': cols == 4}">
      <div class="btn btn--bordered" v-if="min != 0 && item[ID] < min" style="border-color:#e4e4e4">
          <span>{{item[TEXT]}}</span>
      </div>
  		<div class="btn btn--bordered" :class="{'btn--selected': item[ID] === value}" @click="set(item[ID])" v-else>
          <span>{{item[TEXT]}}</span>
  		</div>
  	</div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="showMore">
          <div class="btn btn--bordered btn-more" @click.prevent="showMore = false; optionsToShow = showAll">More...</div>
      </div>
  </div>
</template>

<script>
export default {
	props: {
		items: [Object, Array],
		value: [String, Number],
    min: Number,
		cols: {
			type: Number,
			default: 2
		},
		showMoreButton: {
			type: Boolean,
			default: false
		},
		numberOfOptionsToShow: {
			type: Number,
			default: 100 // this is infinite
		},
		title: String
	},
	data: function() {
		return {
			ID: 0,
			TEXT: 1,
         CUSTOM_TEXT: 2,
			selected: this.value,
		   showMore: this.showMoreButton,
		   optionsToShow: (!this.value || this.value <= this.numberOfOptionsToShow) ? this.numberOfOptionsToShow : 100,
		   showAll: 100 // this is infinite
		}
	},
	watch:{
		showMoreButton: function(val) {
			if (val && this.optionsToShow !== 100) {
				this.showMore = true;
			} else {
				this.showMore = false;
			}
		}
	},
	methods: {
		set: function(id) {
			if(id === this.selected) {
				this.selected = -1;
				// Show 'more' button if still not clicked
				// if (this.showMoreButton && id && this.optionsToShow === this.numberOfOptionsToShow) {
				// 	this.showMore = true;
				// }
			} else {
				this.selected = id;
				// this.showMore = false;
			}
			this.$emit('input', this.selected);
			this.$emit('changed', this.selected);
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/OptionButtons.vue